const textures = [
  '/simulator/images/shirts/s-all-base-ptn-107',
  '/simulator/images/shirts/s-all-base-ptn-110',
  '/simulator/images/shirts/s-all-base-ptn-111',
  '/simulator/images/shirts/s-all-base-ptn-114',
  '/simulator/images/shirts/s-all-base-ptn-120',
  '/simulator/images/shirts/s-all-base-ptn-125',
  '/simulator/images/shirts/s-all-base-ptn-201',
  '/simulator/images/shirts/s-all-base-ptn-202',
  '/simulator/images/shirts/s-all-base-ptn-205',
  '/simulator/images/shirts/s-all-base-ptn-210',
  '/simulator/images/shirts/s-all-base-ptn-214',
  '/simulator/images/shirts/s-all-base-ptn-216',
  '/simulator/images/shirts/s-all-base-ptn-224',
  '/simulator/images/shirts/s-all-base-ptn-311',
  '/simulator/images/shirts/s-all-base-ptn-321',
  '/simulator/images/shirts/s-all-base-ptn-331',
  '/simulator/images/shirts/s-all-base-ptn-341',
  '/simulator/images/shirts/s-all-base-ptn-351',
  '/simulator/images/shirts/s-all-base-ptn-361',
  '/simulator/images/shirts/s-all-base-ptn-371',
  '/simulator/images/shirts/s-all-base-ptn-381',
  '/simulator/images/shirts/s-all-base-ptn-411',
  '/simulator/images/shirts/s-all-base-ptn-421',
  '/simulator/images/shirts/s-all-base-ptn-431',
  '/simulator/images/shirts/s-all-base-ptn-441',
  '/simulator/images/shirts/s-all-base-ptn-451',
  '/simulator/images/shirts/s-all-base-ptn-461',
  '/simulator/images/shirts/s-all-base-ptn-471',
  '/simulator/images/shirts/s-all-base-ptn-481',
  '/simulator/images/shirts/s-all-base-ptn-511',
  '/simulator/images/shirts/s-all-base-ptn-521',
  '/simulator/images/shirts/s-all-base-ptn-531',
  '/simulator/images/shirts/s-all-base-ptn-541',
  '/simulator/images/shirts/s-all-base-ptn-611',
  '/simulator/images/shirts/s-all-base-ptn-621',
  '/simulator/images/shirts/s-all-base-ptn-631',
  '/simulator/images/shirts/s-all-base-ptn-641',
  '/simulator/images/shirts/s-all-base-ptn-651',
  '/simulator/images/shirts/s-all-base-ptn-661',
  '/simulator/images/shirts/s-all-base-ptn-671',
  '/simulator/images/shirts/s-all-base-ptn-701',
  '/simulator/images/shirts/s-all-base-ptn-710',
  '/simulator/images/shirts/s-all-base-ptn-911',
  '/simulator/images/shirts/s-all-base-ptn-921',
  '/simulator/images/shirts/s-all-base-ptn-931',
  '/simulator/images/shirts/s-all-base-ptn-941',
]
export default textures